import Moon from '@/assets/svg/Moon.svg';
import Sun from '@/assets/svg/Sun.svg';
import { useTheme } from '@/context/useTheme';
import { useEffect } from 'react';

const ThemeBtn = () => {
    const { theme, toggleTheme } = useTheme();

    useEffect(() => {
        if (theme === 'dark') {
            document.body.classList.add(theme);
        } else {
            document.body.classList.remove('dark');
        }
        localStorage.setItem('theme', theme);
    }, [theme]);

    return (
        <li
            onClick={toggleTheme}
            className={`py-[3px] rounded-full flex items-center cursor-pointer w-16 ${theme === 'dark' ? 'bg-bg-gray' : 'bg-[#F0F1F3]'}`}
        >
            {theme === 'dark' ? (
                <div className="bg-Grey70 rounded-full drop-shadow-[0_0_5px_#00000011] p-[2px] mx-[3px] translate-x-0 transition-all">
                    <img src={Moon} alt="Theme" className="" />
                </div>
            ) : (
                <div className="bg-white rounded-full drop-shadow-[0_0_10px_#bbb] p-[2px] mx-[3px] translate-x-full rtl:-translate-x-full transition-all">
                    <img src={Sun} alt="Theme" className="" />
                </div>
            )}
        </li>
    );
};
export default ThemeBtn;
